module.exports = "/layout/app/images/logo-light.d9167ea0.svg";